import React from "react";

const Navbar = (props) => {
  const userData = props.userJson;
  const img_url =
    userData.picture_url === null
      ? `${process.env.REACT_APP_BASE_API_URL}/FileStorage/Other/no-avatar.jpg`
      : userData.picture_url;
  const fullname =
    userData.full_name === null ? "در حال بروزرسانی" : userData.full_name;
  const semat =
    userData.semat_title === null ? "در حال بروزرسانی" : userData.semat_title;
  return (
    <React.Fragment>
      <nav className="wp-nav container-fluid">
        <div className="row m-0">
          <div className="col-auto">
            <img src={img_url} className="img-circle avatar" alt="user"></img>
          </div>
          <div className="col-auto align-self-center">
            <p className="text-right wp-text wp-text-bold mb-0">{fullname}</p>
            <p className="dina-fc-blue wp-price mb-0">{semat}</p>
          </div>
        </div>
      </nav>
    </React.Fragment>
  );
};

export default Navbar;
